import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  OverLayData,
  truncateString,
} from "../../ReUseFunctions/ReuseFunctions";

export default function UrlIntegratedTable(props) {
  return (
    <div>
      <div className="sb-table-div sb-table-setion">
        <Paper
          sx={{ width: "100%", overflow: "hidden" }}
          className="table-main-div"
        >
          <TableContainer
          //   onScroll={(e) =>
          //     handleScroll(
          //       e,
          //       props.users,
          //       props.totalUserCount,
          //       props.setLoading,
          //       props.setPageSize,
          //       props.PageSize
          //     )
          //   }
          >
            <Table
              stickyHeader
              aria-label="sticky table table-responsive"
              className="branch-table"
            >
              <TableHead className="custom-table-header">
                <TableRow>
                  {props.tableHeader.map((data, i) => (
                    <TableCell key={i} align={data?.align}>
                      {data?.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>Vendor</TableCell>
                  <TableCell>Get</TableCell>
                  <TableCell>
                    <div>Key : Name | Value : ABC</div>
                    <div>Key : Name | Value : ABC</div>
                    <div>Key : Name | Value : ABC</div>
                  </TableCell>
                  <TableCell>No Auth</TableCell>
                  <TableCell>
                    <div>Key : Name | Value : ABC</div>
                    <div>Key : Name | Value : ABC</div>
                  </TableCell>
                  <TableCell>Form-Data</TableCell>

                  <TableCell align="center">
                    <div className="edit-view-link">
                      <div
                        className="edit-icon-text"
                        // onClick={() => {
                        //   props.openCloseAddEditModel();
                        //   props.setModuleID(2);
                        // }}
                      >
                        <span className="hv-center">
                          <i className="fa fa-edit" />
                          Edit
                        </span>
                      </div>
                      <div className="view-icon-text">
                        <span className="hv-center">
                          <i className="fa fa-eye" />
                          View
                        </span>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </div>
  );
}
